
interface OrderItem {
  product_id: number;
  quantity: number;
  unit_price: number;
  name?: string;
  image?: string;
}

interface OrderItemsProps {
  items: OrderItem[];
}

export default function OrderItems({ items }: OrderItemsProps) {
  return (
    <div className="space-y-4">
      {items.map((item, idx) => (
        <div
          key={`${item.product_id}-${idx}`}
          className="flex items-center gap-4 p-4 bg-[#FAFDF7] rounded-xl"
        >
          {item.image ? (
            <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-gray-50">
              <img
                src={item.image}
                alt={item.name || `Product ${item.product_id}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ) : (
            <div className="w-16 h-16 rounded-lg bg-[#E8F5E9] flex items-center justify-center flex-shrink-0">
              <i className="ri-gift-line text-xl text-[#2E7D32]"></i>
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {item.name || `Product #${item.product_id}`}
            </p>
            <p className="text-xs text-gray-500 mt-0.5">Qty: {item.quantity}</p>
          </div>
          <p className="text-sm font-semibold text-gray-900 flex-shrink-0">
            ${(item.unit_price * item.quantity).toFixed(2)}
          </p>
        </div>
      ))}
    </div>
  );
}
